import React from 'react';

import SnapshotVideo from './SnapshotVideo';
import SnapshotInfo from './SnapshotInfo';
import { imageFix } from '../../../helpers';
import './Snapshot.css';

function Snapshot(props: { post: ReportPost }) {
  const photo =
    props.post.type === 'photo' ||
    props.post.type === 'story_photo' ||
    props.post.type === 'video' ||
    props.post.type === 'gallery_photo' ? (
      <img src={imageFix(props.post.thumbnail)} alt="Instagram post" className="ig-post" />
    ) : (
      <SnapshotVideo url={props.post.media} img={props.post.thumbnail} />
    );

  return (
    <div className="col-md-2 snap page-break" style={{ float: 'none' }}>
      <div style={{ margin: '0px 5px' }}>
        {['story_video', 'story_photo'].includes(props.post.type) ? (
          photo
        ) : (
          <a href={props.post.post_url} target="_blank" rel="noopener noreferrer">
            {photo}
          </a>
        )}
        <SnapshotInfo post={props.post} />
      </div>
    </div>
  );
}

export default Snapshot;
